/**
 * 自动生成， 请不要手工修改！
 */

import { GenericEntityMessage } from "@/services/message/entity/api/GenericEntityMessage";
import { TypeFactory } from "../../../serialize/TypeFactory";
import { CoworkOperation } from "@/services/datatype/cowork/CoworkOperation";

export abstract class AbstractCoworkOperationMessage extends GenericEntityMessage<CoworkOperation> {
  constructor() {
    super();
  }

  public fillFromJson(json: Object, factory?: TypeFactory) {
    if (factory) {
      super.fillFromJson(json, factory);
    } else {
      super.fillFromJson(json);
    }
  }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "CoworkOperationMessage";
    }
  }

  public getTypeId(): string {
    return "CoworkOperationMessage";
  }

  public getClassName(): string {
    return "com.gong_wei.common.message.entity.cowork.CoworkOperationMessage";
  }
}
